export const VISITS_HISTORY_PATH = "/visits/history";

export function serviceReportPdfPath(id: string, token: string) {
  return `/visits/service-reports/${id}/view-pdf?token=${token}`;
}
